<template>
	<div class="ss-content follow-content">
		<div class="ss-container">
			<div class="ss-container__left">
				<div class="follow-box">
					<div class="follow-title">我的粉丝</div>
					<ssUserList :value="curData_" mode="2" :finish="finish_" :busy="busy_" />
					<div class="right-navigation-box">
						<ssNavigation v-if="pageTotal_ > pageSize" :total="pageTotal_" v-model="curPage" :size="pageSize" />
					</div>
				</div>
			</div>
			<div class="ss-container__right">
				<ssUserInfoRight />
			</div>
		</div>
	</div>
</template>

<script>
	import ssUserInfoRight from '@/components/ss-user-info-right/ss-user-info-right.vue'
	import ssUserList from '../../components/ss-user-list/ss-user-list.vue'
	import listMixin from '@/mixins/list.js'
	export default {
		mixins: [ listMixin ],
		name: 'culturalActivity',
		components:{
			ssUserInfoRight,
			ssUserList
		}
	}
</script>

<style lang="scss">
	@import '@/views/cultureCircles/css/follow.scss';
</style>
